import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";

// dev & stag
// const firebaseConfig = {
//   apiKey: "AIzaSyAc7RJh_7p8RNtJTwhNbpJt6xFpZ4LM6F4",
//   authDomain: "trransferdevstag.firebaseapp.com",
//   databaseURL:
//     "https://trransferdevstag-default-rtdb.asia-southeast1.firebasedatabase.app/",
//   // databaseURL: "https://trransferstag.asia-southeast1.firebasedatabase.app/",
//   projectId: "trransferdevstag",
//   storageBucket: "trransferdevstag.firebasestorage.app",
//   messagingSenderId: "659349317020",
//   appId: "1:659349317020:web:dc34cff169a276c0d81459",
//   measurementId: "G-1W47FKXBYS"
// };

// prod
const firebaseConfig = {
  apiKey: "AIzaSyDWI2z8815rnq-lF5UH4bzXbECcAsIfaUI",
  authDomain: "trransferprod.firebaseapp.com",
  databaseURL:
    "https://trransferprod-default-rtdb.asia-southeast1.firebasedatabase.app/",
  projectId: "trransferprod",
  storageBucket: "trransferprod.firebasestorage.app",
  messagingSenderId: "643426386128",
  appId: "1:643426386128:web:838abdb8b22c8ec8d99ed5",
  measurementId: "G-XQRNQBBS0D"
};

firebase.initializeApp(firebaseConfig);

const firebaseAuth = firebase.auth();

const firebaseDB = firebase.database();

export { firebaseAuth, firebaseDB };



// WEBPACK FOOTER //
// ./src/plugins/firebase.js